import { useField } from "@unform/core";
import React, {
  ChangeEvent,
  InputHTMLAttributes,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { FiCheckSquare, FiUploadCloud } from "react-icons/fi";

interface FileUploadProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  fileLabel: string;
  classNameCSS?: string;
}

const ManyFileUpload: React.FC<FileUploadProps> = ({
  name,
  fileLabel,
  label,
  children,
  classNameCSS,
  ...rest
}) => {
  const { fieldName, registerField, error, clearError } = useField(name);
  const [attached, setAttached] = useState(false);
  const [nameFile, setNameFile] = useState(null);
  const [moreThan4Files, setMoreThan4Files] = useState(false);

  const inputRef = useRef<HTMLInputElement>(null);

  const handlePreview = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;

    if (files.length <= 4) {
      setMoreThan4Files(false);
      setNameFile(
        `${files.length} ${
          files.length > 1 ? "Documentos anexados" : "Documento anexado"
        }`
      );
      setAttached(true);
    } else {
      setMoreThan4Files(true);
      setAttached(false);
      setNameFile(null);
    }

    clearError();
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: "files",
      setValue(_: HTMLInputElement, value: string) {
        setAttached(true);
      },
      clearValue(ref: HTMLInputElement) {
        ref.value = "";
        setAttached(false);
      },
    });
  }, [fieldName, registerField]);

  return (
    <div
      className={
        "file is-large is-centered is-boxed mb-5 has-name is-boxed " +
        classNameCSS
      }
    >
      <label className="file-label">
        <label className="label">{label}</label>
        <input
          ref={inputRef}
          className="file-input"
          name={fieldName}
          onChange={handlePreview}
          capture="user"
          accept=".pdf,.doc,.docx,application/msword,image/png,image/jpeg,image/jpg"
          {...rest}
        />
        <span
          className={
            error || moreThan4Files ? "file-cta border-error-file" : "file-cta"
          }
        >
          {attached && (
            <>
              <span className="file-icon">
                <FiCheckSquare className="has-text-success" />
              </span>
              <span className="file-label">{"Documento(s) anexado(s)"}</span>
              <small className="is-size-6">
                (Clique aqui para ALTERAR o documento)
              </small>
            </>
          )}
          {!attached && (
            <>
              <span className="file-icon">
                <FiUploadCloud />
              </span>
              <span className="file-label">{fileLabel}</span>
            </>
          )}
        </span>

        {nameFile && <span className="file-name is-size-6">{nameFile}</span>}
      </label>
      {error && (
        <small className="has-text-danger-dark is-size-6">{error}</small>
      )}

      {moreThan4Files && (
        <small className="has-text-danger-dark is-size-6">
          Insira até 4 arquivos!
        </small>
      )}
    </div>
  );
};

export default ManyFileUpload;
